import { useContext } from 'react';

import { TrackingConsentContext } from './context';

export function useTrackingConsent() {
  return useContext(TrackingConsentContext);
}
